import { ERC20 } from 'src/common/types/models/Tokens'
import { BASE_KNOWN_ERC20 } from './consts'

export const POLYGON_KNOWN_TOKENS: Record<string, ERC20> = {
  SMT: {
    id: '0xE631DABeF60c37a37d70d3B4f812871df663226f',
    contractAddress: '0xE631DABeF60c37a37d70d3B4f812871df663226f',
    name: 'Swarm Markets',
    symbol: 'SMT',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
  },
  WETH: {
    id: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    contractAddress: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    name: 'Wrapped Ether',
    symbol: 'WETH',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
  },
  USDC: {
    id: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    contractAddress: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    name: 'USD Coin',
    symbol: 'USDC',
    decimals: 6,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/3408.png',
  },
  USDT: {
    id: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    contractAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    name: 'Tether USD',
    symbol: 'USDT',
    decimals: 6,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/825.png',
  },
  DAI: {
    id: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    contractAddress: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    name: 'Dai Stablecoin',
    symbol: 'DAI',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/4943.png',
  },
  XCARBON: {
    id: '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89',
    contractAddress: '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89',
    name: 'Swarm Protocol: BiocharNow Carbon Tonne',
    symbol: 'xCharNow',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
    logo: '',
  },
}
